import { StyleSheet, Text, View } from "react-native";
import { useTranslation } from "@luna-restaurant/i18n";
import { useCustomTheme } from "@luna-restaurant/ui";
export const SchoolHolidayIndicator = ({ style, }) => {
    const { colors, fonts } = useCustomTheme();
    const { t } = useTranslation();
    return (<View style={[
            styles.container,
            { backgroundColor: colors.palette.banana90 },
            style,
        ]}>
      <Text style={styles.text}>🏝️</Text>
      <Text style={[styles.text, { ...fonts.display }]}>
        {t("common.schoolHolidays")}
      </Text>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        paddingVertical: 20,
        gap: 16,
        borderRadius: 6,
    },
    text: {
        fontSize: 44,
        lineHeight: 48.4,
    },
});
//# sourceMappingURL=SchoolHolidayIndicator.js.map